import { FINANCE_NAVIGATION_TYPE, FINANCE_NAVIGATION_URL } from '../constants/bottomNavigationBar.mjs';
import { NF_HEADER_SERVICE_TYPE, NF_HEADER_SERVICE_INFO } from '../constants/global.mjs';
import { NPAY_URL } from '../constants/url.mjs';
import { GlobalConfig } from '../globalConfig.mjs';

function getServiceHost(serviceType) {
  switch (serviceType) {
    case NF_HEADER_SERVICE_TYPE.STOCK:
      return GlobalConfig.stockDomain;
    case NF_HEADER_SERVICE_TYPE.REAL_ESTATE:
      return GlobalConfig.realEstateDomain;
    case NF_HEADER_SERVICE_TYPE.INSURANCE:
      return GlobalConfig.insuranceDomain;
    case NF_HEADER_SERVICE_TYPE.MY_ASSET:
    case NF_HEADER_SERVICE_TYPE.PAYMENT:
    case NF_HEADER_SERVICE_TYPE.FINANCE:
    default:
      return GlobalConfig.payDomain;
  }
}
function getServiceUrl(serviceType) {
  return getServiceHost(serviceType) + NF_HEADER_SERVICE_INFO[serviceType].href;
}
function getFinanceServiceUrl(financeType) {
  if (financeType === FINANCE_NAVIGATION_TYPE.INSURANCE) {
    return GlobalConfig.insuranceDomain;
  }
  return GlobalConfig.payDomain + FINANCE_NAVIGATION_URL[financeType];
}
function getFooterServiceUrl(href) {
  switch (href) {
    case NPAY_URL.TERMS_POLICY:
    case NPAY_URL.PRIVACY:
    case NPAY_URL.CREDIT_INFO_USAGE:
    case NPAY_URL.LOAN_SOLICITATION_TERMS:
    case NPAY_URL.NAVER_FINANCIAL_TERMS_POLICY:
      return GlobalConfig.payDomain + href;
    case NPAY_URL.STOCK.NOTICE:
      return GlobalConfig.stockDomain + href;
    case NPAY_URL.REAL_ESTATE_OPEN_SOURCE_LICENSE:
      return GlobalConfig.realEstateDomain + href;
    default:
      return href;
  }
}

export { getFinanceServiceUrl, getFooterServiceUrl, getServiceHost, getServiceUrl };
